import React from 'react';
import { cn } from '../../utils';

const Slider = ({ min = 0, max = 100, value, onChange, onValueChange, className, step = 1, ...props }) => {
  // Support both array format [val] and plain number
  const currentValue = Array.isArray(value) ? value[0] : (value ?? min);

  const handleChange = (e) => {
    const newValue = Number(e.target.value);

    if (onChange) {
      onChange(newValue);
    }
    if (onValueChange) {
      onValueChange([newValue]);
    }
  };

  const percent = ((currentValue - min) / (max - min)) * 100;

  return (
    <div className={cn("relative w-full", className)}>
      <input
        type="range"
        min={min}
        max={max}
        step={step}
        value={currentValue}
        onChange={handleChange}
        className="w-full h-2 rounded-lg appearance-none cursor-pointer slider-track"
        style={{
          background: `linear-gradient(to right, #8b5cf6 0%, #8b5cf6 ${percent}%, #334155 ${percent}%, #334155 100%)`
        }}
        {...props}
      />
      <style>{`
        .slider-track::-webkit-slider-thumb {
          appearance: none;
          width: 20px;
          height: 20px;
          background: #8b5cf6;
          cursor: pointer;
          border-radius: 50%;
          border: 2px solid white;
          box-shadow: 0 2px 6px rgba(0,0,0,0.3);
          transition: transform 0.15s ease;
        }
        .slider-track::-webkit-slider-thumb:hover {
          transform: scale(1.15);
        }
        .slider-track::-webkit-slider-thumb:active {
          transform: scale(1.25);
          background: #7c3aed;
        }
        .slider-track::-moz-range-thumb {
          width: 20px;
          height: 20px;
          background: #8b5cf6;
          cursor: pointer;
          border-radius: 50%;
          border: 2px solid white;
          box-shadow: 0 2px 6px rgba(0,0,0,0.3);
        }
        .slider-track::-moz-range-track {
          background: transparent;
          border: none;
        }
      `}</style>
    </div>
  );
};

export { Slider };
